(() => {
    const buttons = document.querySelectorAll("[data-lc-share]");
    const dialog = document.querySelector("[data-lc-share-dialog]");
    const status = document.querySelector("[data-lc-share-status]");
    let returnFocus = null;

    if (!buttons.length || !dialog) return;

    const setStatus = (message) => {
        if (status) status.textContent = message;
    };

    const canonicalUrl = () =>
        document.querySelector('link[rel="canonical"]')?.href || window.location.href;

    const copyLink = async (url) => {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
            return;
        }

        const input = document.createElement("input");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.select();
        const copied = document.execCommand("copy");
        input.remove();
        if (!copied) throw new Error("Copy unavailable");
    };

    const title = () => dialog.dataset.shareTitle || document.title;
    const focusable = () => Array.from(dialog.querySelectorAll(
        'button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    ));

    const closeDialog = () => {
        if (!dialog.open) return;
        dialog.close();
        returnFocus?.focus();
        returnFocus = null;
    };

    const trapFocus = (event) => {
        if (event.key === "Escape") {
            event.preventDefault();
            closeDialog();
            return;
        }

        if (event.key !== "Tab") return;
        const items = focusable();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };

    const encoded = (value) => encodeURIComponent(value);
    const setDestinations = () => {
        const url = canonicalUrl();
        dialog.querySelector("[data-lc-share-email]").href = `mailto:?subject=${encoded(title())}&body=${encoded(url)}`;
        dialog.querySelector("[data-lc-share-linkedin]").href = `https://www.linkedin.com/sharing/share-offsite/?url=${encoded(url)}`;
        dialog.querySelector("[data-lc-share-facebook]").href = `https://www.facebook.com/sharer/sharer.php?u=${encoded(url)}`;
        dialog.querySelector("[data-lc-share-x]").href = `https://twitter.com/intent/tweet?text=${encoded(title())}&url=${encoded(url)}`;
    };

    buttons.forEach((button) => button.addEventListener("click", () => {
        returnFocus = button;
        dialog.dataset.shareTitle = button.dataset.shareTitle || document.title;
        setStatus("");
        setDestinations();
        dialog.showModal();
        dialog.querySelector("[data-lc-share-close]").focus();
    }));

    dialog.querySelector("[data-lc-share-close]").addEventListener("click", closeDialog);
    dialog.addEventListener("keydown", trapFocus);
    dialog.addEventListener("cancel", (event) => {
        event.preventDefault();
        closeDialog();
    });
    dialog.addEventListener("click", (event) => {
        if (event.target === dialog) closeDialog();
    });

    dialog.querySelector("[data-lc-share-copy]").addEventListener("click", async () => {
        const url = canonicalUrl();
        try {
            await copyLink(url);
            setStatus("Article link copied to your clipboard.");
        } catch {
            setStatus(`Copy this article link: ${url}`);
        }
    });

    const nativeButton = dialog.querySelector("[data-lc-share-native]");
    if (!navigator.share) nativeButton.hidden = true;
    nativeButton.addEventListener("click", async () => {
        try {
            await navigator.share({title: title(), url: canonicalUrl()});
            setStatus("Article shared.");
        } catch (error) {
            if (error?.name === "AbortError") return;
            try {
                await copyLink(canonicalUrl());
                setStatus("Sharing was unavailable, so the article link was copied instead.");
            } catch {
                setStatus(`Copy this article link: ${canonicalUrl()}`);
            }
        }
    });
})();
